<template>
  <v-dialog v-model="imageObject.dialog" width="700">
    <v-card class="dialog-cls">
      <v-card-title class="header-title">Crop Image
        <v-spacer></v-spacer>
        <v-icon
          :disabled="imageObject.loading"
          class="vuetify-icon"
          @click="imageObject.dialog = false"
          color="white">close</v-icon>
      </v-card-title>
      <v-card-text class="pa-4">
        <v-row>
          <v-col cols="6">
            <cropper
              ref="cropper"
              class="cropper"
              :src="imageObject.image"
              :stencilProps="{
                aspectRatio: imageObject.width / imageObject.height,
              }"
              :minWidth="imageObject.width"
              :minHeight="imageObject.height"
              @change="onChange"
            />
          </v-col>
          <v-col cols="6" class="text-center">
            <div class="preview-result-example__previews">
              <preview
                class="preview-result-example__preview d-inline-block mx-0"
                :image="result.image"
                :coordinates="result.coordinates"
                :width="200"
                :height="200"
              />
            </div>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider class="ma-0"></v-divider>
      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn color="gray" @click="imageObject.dialog = false" :disabled="imageObject.loading">Cancel</v-btn>
        <v-btn color="#344452" dark @click="cropImage" :loading="imageObject.loading">Crop & Upload</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { Cropper,Preview } from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css';
import { MediaService } from "@/services";
export default {
  name: "ImageCropper",
  components: {
    Cropper,
    Preview,
  },
  props: {
    imageObject:{
      type:Object,
      default:()=>{}
    },
    moduleId:null,
    media:{
      type:Array,
      default:()=>[]
    },
  },
  data() {
    return {
      result: {
        coordinates: null,
        image: null,
      },
      width: 0,
      height: 0,
    };
  },
  methods: {
    refresh(){
      console.log("called  ");
      this.$refs.cropper.reset()
    },
    onChange({ coordinates, image }) {
      this.result = {
        coordinates,
        image,
      };
    },
    cropImage() {
      const { canvas } = this.$refs.cropper.getResult();
      let croppedUrl =  canvas.toDataURL();
      this.dataURLtoFile(
        croppedUrl,
        this.imageObject.originalFile.name
      );
      this.UploadImage()
    },
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      this.imageObject.croppedFile = new File([u8arr], filename, {
        type: mime,
      });
    },
   async UploadImage(){
      this.imageObject.loading = true;
      let formData = new FormData();
      formData.append("mediaType", "image");
      formData.append("moduleType", "newsFeed");
      formData.append("mediaSubType", "file");
      formData.append("imageType", this.imageObject.mediaType);
      formData.append("moduleId", this.moduleId);
      formData.append("file", this.imageObject.originalFile);
      formData.append("croppedFile", this.imageObject.croppedFile);
      const response = await MediaService.uploadFile(formData);
        if (response) {
           const promises = [];
          this.media.forEach((media) => {
              const deleteResponse = new Promise( (resolve,reject)=>{
              const response = MediaService.deleteMedia({
              id: media._id,
              body: {
                moduleType: "newsFeed",
                moduleId: this.moduleId,
              },
            });
            resolve(response);
             })
            promises.push(deleteResponse);
        })
        Promise.all(promises).then(()=>{
          this.$emit('updateMedia',this.imageObject.mediaType);
          this.$store.dispatch(
            "user/setSnack",
            "Newsfeed Image uploaded successfully!"
          );
          this.$store.dispatch("user/setType", "info");
        this.imageObject.loading = false;
        this.imageObject.dialog = false;
        })
       }
        
    },
  },
};
</script>
<style lang="scss">
.dialog-cls {
  .scroll-box {
    max-height: 620px;
    overflow-y: auto;
  }
}
.preview-result-example {
	display: flex;
	&__cropper {
		width: 300px;
	}
	&__preview-image {
		width: 100%;
	}
}
</style>